import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { toast } from "react-toastify";
import adminHttp from "../../../utils/adminHttp";

type Payload = {
  email: string;
  lastName: string;
  firstName: string;
  role: string

}

export const useInviteNewAdminUser = () => {
  const queryClient = useQueryClient();
  const { mutate, data, variables, ...rest } = useMutation({
    mutationKey: ['invite new admin user'],
    mutationFn: async ({ ...credentials }: Payload) => {
      const response = await adminHttp.post("admins/invite", { ...credentials });
      return response.data;
    },

    onSuccess: () => {
      toast.success(
        `Inviation successful`,
        { toastId: "customId" }
      );
      queryClient.invalidateQueries({
        queryKey: ["get admin provider list"] as const
      });
    },

    onError: (error) => {
      if (axios.isAxiosError(error)) {
        toast.error(
          error.response?.statusText || `Error inviting user`,
          { toastId: "customId" }
        );

      } else {
        toast.error(
          error?.message
          || "Error processing your request",
        );
      }
    },
  });

  return {
    inviteNewAdminUser: mutate,
    data,
    variables,
    ...rest,
  };
}